import React from "react";
import Pipeline from "./components/pipeline/Pipeline";

const PipelinePage = (props) => <Pipeline {...props} />;
export default PipelinePage;
